export class DeductibleResponse {
    vehicleDeductibles: DeductibleOption[];
    franchiseTypePublicId: 'AccidenteParcialDeduciblePorcentualTerm' | 'AccidenteParcialDeducibleDirectoTerm';

    constructor(data?: Partial<DeductibleResponse>) {
        if (data) {
            Object.assign(this, data);
        }
    }
}

export class DeductibleOption {
    code: string = null;
    description: string = null;
    isSelected = false;

    constructor(data?: Partial<DeductibleOption>) {
        if (data) {
            Object.assign(this, data);
        }
    }
}